<template>
    <div class="insights-kpi-cards">
        <div class="kpi-card" v-for="kpi in kpis" :key="kpi.key">
            <div class="kpi-icon">
                <i class="material-icons">{{ kpi.icon }}</i>
            </div>
            <div class="kpi-body">
                <div class="kpi-label">{{ $t(kpi.labelKey) }}</div>
                <div class="kpi-value" v-if="!loading">{{ kpi.value }}</div>
                <a-skeleton-input v-else :active="true" size="small" :style="{ width: '90px' }" />
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";

const formatNumber = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    const num = Number(val);
    if (isNaN(num)) return val;
    return num.toLocaleString("tr-TR", { maximumFractionDigits: 2 });
};

const formatCurrency = (val, currency) => {
    if (val === null || val === undefined || val === "") return "-";
    const num = Number(val);
    if (isNaN(num)) return val;
    return num.toLocaleString("tr-TR", { maximumFractionDigits: 2 }) + " " + (currency || "");
};

const formatPercent = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    const num = Number(val);
    if (isNaN(num)) return val;
    return num.toLocaleString("tr-TR", { maximumFractionDigits: 2 }) + "%";
};

export default {
    name: "InsightsKpiCards",
    props: {
        insights: {
            type: Object,
            default: () => ({}),
        },
        currency: {
            type: String,
            default: "",
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        kpis() {
            const ins = this.insights || {};
            return [
                {
                    key: "spend",
                    icon: "payments",
                    labelKey: "metaInsights.kpi.spend",
                    value: formatCurrency(_.get(ins, "spend"), this.currency),
                },
                {
                    key: "impressions",
                    icon: "visibility",
                    labelKey: "metaInsights.kpi.impressions",
                    value: formatNumber(_.get(ins, "impressions")),
                },
                {
                    key: "reach",
                    icon: "groups",
                    labelKey: "metaInsights.kpi.reach",
                    value: formatNumber(_.get(ins, "reach")),
                },
                {
                    key: "clicks",
                    icon: "ads_click",
                    labelKey: "metaInsights.kpi.clicks",
                    value: formatNumber(_.get(ins, "clicks")),
                },
                {
                    key: "ctr",
                    icon: "trending_up",
                    labelKey: "metaInsights.kpi.ctr",
                    value: formatPercent(_.get(ins, "ctr")),
                },
                {
                    key: "cpm",
                    icon: "stacked_line_chart",
                    labelKey: "metaInsights.kpi.cpm",
                    value: formatCurrency(_.get(ins, "cpm"), this.currency),
                },
                {
                    key: "cpc",
                    icon: "monetization_on",
                    labelKey: "metaInsights.kpi.cpc",
                    value: formatCurrency(_.get(ins, "cpc"), this.currency),
                },
                {
                    key: "frequency",
                    icon: "repeat",
                    labelKey: "metaInsights.kpi.frequency",
                    value: formatNumber(_.get(ins, "frequency")),
                },
            ];
        },
    },
};
</script>

<style scoped lang="scss">
.insights-kpi-cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;

    .kpi-card {
        display: flex;
        align-items: center;
        gap: 10px;
        background: var(--color-bg-default);
        border: 1px solid var(--color-border-default);
        border-radius: 8px;
        padding: 14px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
        }

        .kpi-icon {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--color-bg-info-subtle, #eef4ff);
            border-radius: 8px;

            i {
                color: var(--color-text-info-default, #1f6feb);
                font-size: 22px;
            }
        }

        .kpi-body {
            display: flex;
            flex-direction: column;
            gap: 2px;
            flex: 1;

            .kpi-label {
                font-size: 12px;
                color: var(--color-text-muted-default, #6b7280);
                text-transform: uppercase;
                letter-spacing: 0.4px;
            }

            .kpi-value {
                font-size: 20px;
                font-weight: 700;
                color: var(--color-text-strong-default);
            }
        }
    }
}
</style>
